import { useState } from 'react';

const FAQS = [
  {
    q: 'Are there pet-friendly cabins in Highlands NC?',
    a: 'Yes, Highlands offers pet-friendly cabins for visitors traveling with dogs, including cabins located near hiking trails, waterfalls, and downtown. Glen Falls Luxury Cabin, Lark Lodge, and Stag Ridge are among the pet-friendly options in the area.',
  },
  {
    q: 'What are the best pet-friendly cabins in Highlands NC?',
    a: 'Travelers often look for pet-friendly cabins that combine location, comfort, and access to outdoor activities in the Highlands area. Glen Falls Luxury Cabin is one of the most highly rated options, known for its location near Glen Falls and its peaceful wooded setting.',
  },
  {
    q: 'Are there cabins near waterfalls in Highlands NC?',
    a: 'Yes, some cabins in Highlands are located near waterfalls and trail access, making them popular with visitors who want to explore the area\'s natural attractions. Glen Falls Luxury Cabin is one example, situated minutes from Glen Falls.',
  },
  {
    q: 'Is Highlands NC a good destination for a trip with dogs?',
    a: 'Highlands is a strong destination for dog owners thanks to its trails, waterfalls, mountain setting, and pet-friendly lodging options. The combination of cool mountain air, forested surroundings, and outdoor activities makes it a natural fit for traveling with pets.',
  },
  {
    q: 'What dog-friendly activities are available near Highlands NC cabins?',
    a: 'Visitors staying in pet-friendly cabins in Highlands NC have access to Glen Falls, Whiteside Mountain Trail, Highlands Dog Park, and several downtown restaurants with dog-friendly outdoor seating.',
  },
  {
    q: 'How close are pet-friendly cabins to downtown Highlands NC?',
    a: 'Most pet-friendly cabins in the Highlands area are within a short drive of downtown. This makes it easy to combine outdoor activities near the cabin with visits to restaurants and shops in town.',
  },
];

export default function FAQSection() {
  const [openIndex, setOpenIndex] = useState<number | null>(null);

  const toggle = (i: number) => setOpenIndex(openIndex === i ? null : i);

  return (
    <section className="bg-[#F5F1EB] py-24 px-6 lg:px-14">
      <div className="max-w-4xl mx-auto">
        <div className="text-center mb-14">
          <p className="text-[#C9A96E] text-xs tracking-[0.35em] uppercase font-jost mb-4">/ Common Questions</p>
          <h2 className="font-cormorant text-5xl text-[#1A1A18] font-light">
            Frequently Asked Questions
          </h2>
        </div>
        <div className="space-y-3">
          {FAQS.map((faq, i) => (
            <div key={faq.q} className="bg-[#FAFAF8] rounded-2xl overflow-hidden">
              <button
                onClick={() => toggle(i)}
                className="w-full flex items-center justify-between gap-4 p-6 text-left cursor-pointer"
              >
                <span className="font-cormorant text-xl text-[#1A1A18] font-medium leading-snug">{faq.q}</span>
                <div className="w-6 h-6 flex items-center justify-center shrink-0">
                  <i className={`${openIndex === i ? 'ri-subtract-line' : 'ri-add-line'} text-[#2D4A3E] text-base`} />
                </div>
              </button>
              {openIndex === i && (
                <div className="px-6 pb-6">
                  <p className="text-[#5C5850] font-jost text-sm leading-relaxed">{faq.a}</p>
                </div>
              )}
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
